import { IListAPIResponse, IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { SiteSummaryDetails } from '.';
import { APPCONFIG } from '@config/app.config';

export const useSiteSummarySSQuery = (sfid?: string | null): IQueryResponse<IListAPIResponse<SiteSummaryDetails[]>> => {
	const fetchSiteSummarySSData = async (): Promise<IListAPIResponse<SiteSummaryDetails[]>> => {
		const url = `${APPCONFIG.baseUrl}${APPCONFIG.apiVersion}/site-leads/wwa/kae-contractor-site-summary/`;
		return await APIService.getData<IListAPIResponse<SiteSummaryDetails[]>>(url, {
			limit: '0',
			contractor: sfid ?? '',
		});
	};

	const { data, error, isLoading, isPending, isFetching } = useQuery({
		queryKey: ['siteSummarySS'],
		queryFn: fetchSiteSummarySSData,
		enabled: !!sfid,
		refetchOnWindowFocus: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
	};
};
